import { render, staticRenderFns } from "./CaseTypeList.vue?vue&type=template&id=3dbea916&scoped=true"
import script from "./CaseTypeList.vue?vue&type=script&lang=js"
export * from "./CaseTypeList.vue?vue&type=script&lang=js"
import style0 from "./CaseTypeList.vue?vue&type=style&index=0&id=3dbea916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbea916",
  null
  
)

export default component.exports